export interface PayloadWeeklyBoard {
  id_empresa: string;  
  tipos_conteo: string[];
  activos: string[]; 
  anios: string; 
  semanas: string[];
  dias: string[];
}

export type ResponseWeeklyBoard = DashboardChart[];

export type DashboardChart = TotalAggregateChart | DailyAggregate | BranchAggregate | WeeklyTrend | DailyTrend | AssetTrend;

export interface TotalAggregateChart {
  anio_base: number;
  anio_anterior: number;
  nombre: string;
  semanas_filtradas: string[];
  dias_filtrados: number[];
  acumulado_total: TotalAggregate[];
}

export interface TotalAggregate {
  valor_base: number;
  valor_anterior: number;
}

export interface DailyAggregate {
  nombre: string;
  datos: DailyData[];
}

export interface DailyData {
  dia: string;
  nombre_dia: string; 
  anio_base: number; 
  anio_anterior: number; 
  diferencia_porcentual: number;
}

export interface BranchAggregate {
  nombre: string;
  datos: BranchData[];
}

export interface BranchData {
  codigo_sucursal: string;
  nombre_sucursal: string;
  valor_base: number;
  valor_anterior: number;
  diferencia_porcentual: number;
}

export interface WeeklyTrend {
  nombre: string;
  datos: WeeklyTrendData[];
}

export interface WeeklyTrendData {
  semana_actual: string;
  semana_anterior: string;
  valor_semana_actual: number;  
  valor_semana_anterior: number;
}

export interface DailyTrend {
  nombre: string; 
  semana_actual: string;
  semana_anterior: string;
  datos: DailyTrendData[]; 
}

export interface DailyTrendData {
  dia: string;
  nombre_dia: string;
  valor_semana_actual: number; 
  valor_semana_anterior: number;
}

export interface AssetTrend {
  nombre: string; 
  semana_actual: string; 
  semana_anterior: string;
  datos: AssetTrendData[];
}

export interface AssetTrendData {
  codigo_activo: string;
  nombre_activo: string;
  valor_semana_actual: number;
  valor_semana_anterior: number; 
  diferencia_porcentual: number;
}